import i18n from "../../../config/dictionary/i18n";
import dayjs from "dayjs";

/**
 * Formats a date based on locale language.
 *
 * @param date the date to format.
 */
export function formatDate(date: Date) {
    if (!date) {
        return "---";
    }
    //return dayjs(date).format("DD/MM/YYYY HH:mm")
    // Fix use dayjs Locale
    return dayjs(date).format("L LT")
}

export function formatDateWithoutTime(date: Date) {
    if (!date) {
        return "---";
    }
    //return dayjs(date).format("DD/MM/YYYY")
    // Fix use dayjs Locale
    return dayjs(date).format("L")
}

export function formatDateWithoutDay(date: Date) {
    if (!date) {
        return "---";
    }
    return dayjs(date).format('MM/YY');
}


/**
 * Formats a number based on locale language.
 *
 * @param number the number to format.
 */
export function formatNumber(number: number | undefined) {
    if (number === null || number === undefined) {
        return "---";
    }
    return new Intl.NumberFormat(i18n.language).format(number);
}

/**
 * Formats a number in a specific currency based on locale language.
 *
 * @param number the number to format.
 * @param currency the currency to format the number into.
 * @param multiplier the multiplier to apply to the number before formatting. Default: 1.
 */
export function formatCurrency(number: number, currency: string = 'EUR', multiplier: number = 1) {
    if (number === null || number === undefined || Number.isNaN(number)) {
        return "---";
    }
    return new Intl.NumberFormat(i18n.language, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(number * multiplier);
}

export function getCurrencySymbol(currency: string) {
    const formatter = new Intl.NumberFormat(i18n.language, { style: 'currency', currency, });

    let symbol;
    formatter.formatToParts(0).forEach(({ type, value }) => {
        if (type === 'currency') {
            symbol = value;
        }
    });

    return symbol;
}

export function formatToFloat(number: number, multiplier: number){
    return (number * multiplier).toFixed(2)
}